import { render, staticRenderFns } from "./LoginNew.vue?vue&type=template&id=6a98813a&scoped=true&"
import script from "./LoginNew.vue?vue&type=script&lang=js&"
export * from "./LoginNew.vue?vue&type=script&lang=js&"
import style0 from "./LoginNew.vue?vue&type=style&index=0&id=6a98813a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a98813a",
  null
  
)

export default component.exports